import { api } from "./apiSetting";


async function login(username, password) {
    const response = await api.post('/j/login/', {username: username, password: password}, {headers: {'Content-Type': 'multipart/form-data'}})
    return response
}


export { login }
